import { Grid, GridColumn, Text } from '@teliaee/design-system';
import { observer } from 'mobx-react';
import * as React from 'react';
import LoginButton from '../components/LoginButton';
import { runInTeliaRumService } from '../util/TeliaOtelUtil';
import useStores from '../stores/UseStores';
import RememberMe from './RememberMe';

const IdCardLogin = observer((): React.JSX.Element => {
  const {
    idCardLoginStore,
    translateStore: { translate },
    uiStore: { getLoginPanelGridWidth },
  } = useStores();

  const login = (event: React.FormEvent) => {
    runInTeliaRumService('Autentimine (ID-kaart)', () => {
      event.preventDefault();
      idCardLoginStore.handleLogin();
    });
  };

  return (
    <form onSubmit={(event) => login(event)}>
      <Text>
        <Grid align={['center-sm']}>
          <GridColumn width={getLoginPanelGridWidth()}>
            <Text>
              {translate('panel.id.title')}
              <RememberMe tabItemId="idCardLoginTab" />
              <LoginButton isLoading={idCardLoginStore.submitting} disabled={idCardLoginStore.submitting} />
            </Text>
          </GridColumn>
        </Grid>
      </Text>
    </form>
  );
});

export default IdCardLogin;
